export const SUPPORTED_LANGUAGE = {
  english: 'en',
  polish: 'pl',
} as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGE)[keyof typeof SUPPORTED_LANGUAGE];

export const FALLBACK_LANGUAGE: SupportedLanguage = SUPPORTED_LANGUAGE.english;

export const SUPPORTED_LANGUAGE_OPTIONS: SupportedLanguage[] = [
  SUPPORTED_LANGUAGE.english,
  SUPPORTED_LANGUAGE.polish,
];

export function isSupportedLanguage(
  candidateLanguage: string
): candidateLanguage is SupportedLanguage {
  return SUPPORTED_LANGUAGE_OPTIONS.some(function matchesCandidate(supportedLanguage) {
    return supportedLanguage === candidateLanguage;
  });
}
